<template>
  <v-container style="padding-top: 10%;">
    <!-- <div class="mx-auto mb-10 text-subtitle-2" align="center" justify="center">
      <tr align="center">
        Velkommen til vores nye bookingportal.
      </tr>
      <tr align="center">
        Vi har gjort layoutet mere simpelt og brugervenligt, så det er lettere
        at booke kørsel med GLS Express.
      </tr>
      <tr align="center">
        Du får bl.a. nemmere adgang til live tracking og historikken giver et
        bedre overblik over dine bestillinger.
      </tr>
      <tr align="center">
        Vi håber, at du bliver glad for den nye portal.
      </tr>
    </div> -->

    <v-card
      elevation="0"
      class="my-auto mx-auto mb-5 secondary rounded-0"
      align="center"
      justify="center"
    >
      <CardHeader title="Login" />
      <!-- <v-card-title>
        Login
      </v-card-title> -->
      <v-card-subtitle class="pt-5 pb-0 error--text">
        <span v-show="loginFailedAlert">
          {{ loginFailedText }}
        </span>
      </v-card-subtitle>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card-text class="px-10">
          <v-text-field
            name="username"
            label="Brugernavn"
            :rules="nameRules"
            required
            v-model="username"
            autofocus
            outlined
            dense
            color="primary"
            background-color="white"
            @keydown="
              e => {
                keyDownHandler(e);
              }
            "
          ></v-text-field>
          <v-text-field
            name="password"
            label="Password"
            type="password"
            v-model="password"
            :rules="passwordRules"
            required
            outlined
            dense
            color="primary"
            style="margin-bottom: -15px;"
            background-color="white"
            @keydown="
              e => {
                keyDownHandler(e);
              }
            "
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="pt-0 pb-10 px-10">
          <v-btn
            block
            class="text-right"
            @click="loginRequest"
            :disabled="!valid || loggingIn"
          >
            Login
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import CardHeader from "@/components/templates/CardHeader.vue";
export default {
  components: {
    CardHeader
  },
  data: () => ({
    valid: false,
    username: "",
    nameRules: [v => !!v || "Brugernavn skal udfyldes"],
    password: "",
    passwordRules: [v => !!v || "Password skal udfyldes"],
    loginFailedAlert: false,
    loginFailedText: "Brugernavn eller password er forkert"
  }),
  computed: {
    loggingIn() {
      return this.$store.state.authentication.status.loggingIn;
    }
  },
  created() {
    // reset login status
    this.$store.dispatch("authentication/logout");
  },
  methods: {
    async loginRequest() {
      this.$refs.form.validate();
      const { username, password } = this;
      if (username && password) {
        await this.$store.dispatch("authentication/login", {
          username,
          password
        });

        this.loginFailedAlert =
          !this.$store.state.authentication.status.user &&
          !this.$store.state.authentication.status.loggedIn;
      }
    },
    keyDownHandler(e) {
      if (e) {
        const key = window.event ? e.keyCode : e.which;
        // enter
        if (key === 13) {
          this.loginRequest();
        }
      }
    }
  }
};
</script>

<style scoped>
.v-card {
  width: 350px;
}

.v-card__title {
  background-color: #061ab1;
  color: white;
}

.v-card__subtitle {
  height: 35px;
  text-align: center;
}
</style>
